@if (hasFullscreen()) {
	<div [ngbTooltip]="fullscreenTextKey | translate" class="cursor-pointer" (click)="fullscreen()">
		<img [src]="iconSrc" alt="Fullscreen" loading="eager" class="fullscreen-icon" />
	</div>
}
